import Footer from "../components/Footer";

const About = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold text-center mb-6">About Bill-lex</h1>
      <p className="text-lg text-gray-700 mb-6 text-justify">
        <strong>Bill-lex.com</strong> is a comprehensive invoicing and inventory
        management platform tailored specifically for the food and beverage
        industry — including cloud kitchens, restaurants, cafés, lounges, food
        carts, and digital cafés. Whether you're a small local outlet or an
        expanding chain, Bill-lex helps you streamline operations, enhance
        customer experience, and take full control of your billing and
        inventory.
      </p>

      <h2 className="text-2xl font-semibold mb-4">Key Features</h2>
      <ul className="list-disc pl-5 text-gray-700 space-y-2">
        <li>
          <strong>Smart Invoicing:</strong> Seamlessly generate professional
          invoices compatible with both standard and{" "}
          <span className="font-semibold">thermal printers</span>.
        </li>
        <li>
          <strong>Inventory & Stock Management:</strong> Get real-time tracking
          and alerts to avoid overstocking or running out of ingredients.
        </li>
        <li>
          <strong>Data Analytics:</strong> Gain powerful insights into your
          sales, trends, and performance to help make informed decisions.
        </li>
        <li>
          <strong>QR-Based Menus:</strong> Generate clean, mobile-friendly QR
          menus that customers can scan and order from.
        </li>
        <li>
          <strong>Integrated Payments:</strong> Accept payments directly through
          invoices — both in-store and via payment links.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mt-10 mb-4">Pricing</h2>
      <p className="text-gray-700 mb-4">
        Bill-lex is accessible with a simple and transparent pricing model:
      </p>
      <ul className="list-disc pl-5 text-gray-700 space-y-2">
        <li>Monthly subscription at just ₹359.</li>
        <li>Free tier available with limited features for new users.</li>
        <li>
          For merchants using our integrated payment system:
          <ul className="pl-5 list-disc">
            <li>2% platform fee</li>
            <li>10% commission</li>
          </ul>
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mt-10 mb-4">
        Payment & Compliance
      </h2>
      <p className="text-gray-700 mb-6 text-justify">
        We use <strong>Cashfree Payments</strong> as our official payment
        gateway partner to ensure secure, seamless transactions for all
        merchants and customers. Bill-lex fully complies with all guidelines and
        policies set forth by Cashfree to offer a reliable and transparent
        billing experience.
      </p>

      <h2 className="text-2xl font-semibold mb-4">Our Mission</h2>
      <p className="text-gray-700 mb-6 text-justify">
        Our mission is to empower food businesses — big or small — with tools
        that simplify day-to-day operations and foster growth. From billing to
        stock to analytics, we aim to become your all-in-one digital assistant
        in the kitchen and beyond.
      </p>

      <p className="text-sm text-gray-500 text-center mt-10">
        Bill-lex is a product of{" "}
        <strong>Lexora Technologies OPC Private Limited</strong>.
      </p>
      <Footer />
    </div>
  );
};

export default About;
